<template>
  <div 
    v-if="accounts.length > 0"
    :class="`bg-gradient-to-br ${bgGradient} border ${borderColor} rounded-xl p-4`"
  >
    <div class="flex items-center gap-2 mb-3">
      <slot name="icon">
        <svg class="w-6 h-6" :class="iconColor" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      </slot>
      <h4 class="text-white font-semibold text-base">{{ title }}</h4>
      <span :class="`ml-auto px-2.5 py-1 ${badgeBg} ${badgeText} rounded text-sm font-medium`">
        {{ accounts.length }}
      </span>
    </div>
    <div class="space-y-2.5">
      <div 
        v-for="account in accounts" 
        :key="`${keyPrefix}-${account.formId}`" 
        class="text-sm"
      >
        <p class="text-white font-medium truncate text-base">
          {{ account.accountName || account.formTitle || `Form ${account.formId}` }}
        </p>
        <p :class="`${valueColor} text-sm`">
          <slot name="value" :account="account">
            {{ formatValue(account) }}
          </slot>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountHealthCard',
  props: {
    title: {
      type: String,
      required: true
    },
    accounts: {
      type: Array,
      default: () => []
    },
    bgGradient: {
      type: String,
      default: 'from-gray-500/10 to-gray-600/5'
    },
    borderColor: {
      type: String,
      default: 'border-gray-500/20'
    },
    iconColor: {
      type: String,
      default: 'text-gray-400'
    },
    badgeBg: {
      type: String,
      default: 'bg-gray-500/20'
    },
    badgeText: {
      type: String,
      default: 'text-gray-400'
    },
    valueColor: {
      type: String,
      default: 'text-gray-400'
    },
    valueKey: {
      type: String,
      default: 'last30DaysSubmissions'
    },
    valueLabel: {
      type: String,
      default: 'submissions'
    },
    keyPrefix: {
      type: String,
      default: 'health'
    }
  },
  methods: {
    formatValue(account) {
      const value = account[this.valueKey] || 0;
      return `${value} ${this.valueLabel}`;
    }
  }
};
</script>

